import {
  USER_ICON_LITERAL,
  OVERALL_ICON_LITERAL,
  TREND_ICON_LITERAL,
  REPORT_ICON_LITERAL,
  PLAN_ICON_LITERAL,
  LOGGOUT_ICON_LITERAL,
  MONITOR_ICON_LITERAL,
  DEVICE_ICON_LITERAL,
  ALARM_ICON_LITERAL,
  STORAGE_ICON_LITERAL,
  ORDER_ICON_LITERAL,
  EMERGENCY_ICON_LITERAL,
  VIDEO_ICON_LITERAL,
  XUNJIAN_ICON_LITERAL,
  SETTING_ICON_LITERAL,
  PROJECT_ICON_LITERAL,
  DEVICE_ONLINE_ICON_LITERAL,
  DEVICE_OFFLINE_ICON_LITERAL,
  PROJECT_DARK_ICON_LITERAL,
  ALARM_QUERY_ICON_LITERAL, DATA_QUERY_ICON_LITERAL, CONFIGURATION_ICON_LITERAL, PROJECT_LIST_ICON_LITERAL, LAYOUT_SINGLE_ICON_LIGHT, LAYOUT_SINGLE_ICON_DARK, LAYOUT_SINGLE_ICON_ZH, LAYOUT_SINGLE_ICON_EN, PROJECT_INFO_OFFLINE,
  ALARM_EMERGENCY_ICON, ALARM_NORMAL_ICON
} from './../shared/consts/icon-constants';
import { environment } from './../environments/environment.prod';
import { CommonService } from './service/common';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, HostListener, Injector } from '@angular/core';
import { LayoutService } from './service/layout.service';
import { HookService } from 'shared/services/hook.service';
import { SignalrService, SpinningService } from 'shared/services';
import { OverlayService } from 'shared/services/overlay.service';
import { tap } from 'rxjs/operators';
import { OverlayRef, OverlayConfig, Overlay } from '@angular/cdk/overlay';
import { OverlaySpinningComponent } from 'shared/components/overlay-spinning';
import { ComponentPortal } from '@angular/cdk/portal';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService, zh_CN, en_US } from 'ng-zorro-antd/i18n';
import { NzIconService } from 'ng-zorro-antd/icon';
import { SubjectService } from './service/subject.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  isCollapsed = false;

  constructor(
    private iconService: NzIconService,
    private spinningService: SpinningService,
    private overlay: Overlay,
    public translate: TranslateService,
    private i18n: NzI18nService,
    private subject: SubjectService,
    private injector: Injector) {
    this.iconService.addIconLiteral('ng-zorro:user', USER_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:overall', OVERALL_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:trend', TREND_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:report', REPORT_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:plan', PLAN_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:monitor', MONITOR_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:alarm', ALARM_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:order', ORDER_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:emergency', EMERGENCY_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:storage', STORAGE_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:video', VIDEO_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:xunjian', XUNJIAN_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:setting', SETTING_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:logout', LOGGOUT_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:device', DEVICE_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:project', PROJECT_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:device-online', DEVICE_ONLINE_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:device-offline', DEVICE_OFFLINE_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:project-info-offline', PROJECT_INFO_OFFLINE);
    this.iconService.addIconLiteral('ng-zorro:project-dark', PROJECT_DARK_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:alarm-query', ALARM_QUERY_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:data-query', DATA_QUERY_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:configuration', CONFIGURATION_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:project-list', PROJECT_LIST_ICON_LITERAL);
    this.iconService.addIconLiteral('ng-zorro:layout-light', LAYOUT_SINGLE_ICON_LIGHT);
    this.iconService.addIconLiteral('ng-zorro:layout-dark', LAYOUT_SINGLE_ICON_DARK);
    this.iconService.addIconLiteral('ng-zorro:layout-zh', LAYOUT_SINGLE_ICON_ZH);
    this.iconService.addIconLiteral('ng-zorro:layout-en', LAYOUT_SINGLE_ICON_EN);
    this.iconService.addIconLiteral('ng-zorro:alarm-emergency', ALARM_EMERGENCY_ICON);
    this.iconService.addIconLiteral('ng-zorro:alarm-normal', ALARM_NORMAL_ICON);
  }

  spinningRef: OverlayRef;

  ngOnInit(): void {
    this.initTranslate();
    this.translate.onLangChange.subscribe((e) => {
      localStorage.setItem('lang', e.lang)
      const lang = new Map([
        ['en', en_US],
        ['zh', zh_CN]
      ]);
      this.i18n.setLocale(lang.get(localStorage.getItem('lang')));
      location.reload();
    })
    var config: OverlayConfig = {
      hasBackdrop: true,
      backdropClass: 'ant-modal-mask',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position().global(),
      height: '100%',
      width: '100%'
    };
    const ref = this.overlay.create();
    this.spinningService.count$.subscribe(c => {

      if (c > 0 && !ref.hasAttached()) {
        ref.attach(new ComponentPortal(OverlaySpinningComponent, null, this.injector));
      }
      else if (c <= 0 && ref.hasAttached()) {
        ref.detach();
      }
    });

  }

  initTranslate() {
    this.translate.addLangs(['en', 'zh']);
    const lang = localStorage.getItem('lang')
    if (lang && lang != 'undefined') {
      const lang = new Map([
        ['en', en_US],
        ['zh', zh_CN]
      ]);
      this.i18n.setLocale(lang.get(localStorage.getItem('lang')));
    } else {
      this.translate.use('zh');
      window.localStorage.setItem('lang', 'zh');
      window.localStorage.setItem('language', 'zh');
      this.i18n.setLocale(zh_CN);
    }
  }
}
